import { render } from "./hotelSettings.vue?vue&type=template&id=2554e6ce&scoped=true"
import script from "./hotelSettings.vue?vue&type=script&lang=js"
export * from "./hotelSettings.vue?vue&type=script&lang=js"

import "./hotelSettings.vue?vue&type=style&index=0&id=2554e6ce&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2554e6ce"]])

export default __exports__